import { FormActions, SuccessAction, FailAction } from 'common/Form/actions'
import { Product } from 'common/Products/types'
import { RECHARGE_FORM_ID } from 'pages/RechargePage'
import { ADDON_PURCHASE_ID } from 'pages/PurchaseAddonsPage/AddonCheckout'

export interface CheckoutState {
  orderId?: string
  products: Product[]
  retry: boolean
}

export const initialState: CheckoutState = {
  products: [],
  retry: false,
}

const PAYMENT_FORMS = [RECHARGE_FORM_ID, ADDON_PURCHASE_ID]

export default function reducer(
  state = initialState,
  action: SuccessAction | FailAction
): CheckoutState {
  switch (action.type) {
    case FormActions.FORM_SUCCESS:
      if (PAYMENT_FORMS.includes(action.payload.id)) {
        return {
          ...state,
          retry: action.payload.status === 202,
          orderId: action.payload.data.order_code,
        }
      }
      return state
    case FormActions.FORM_FAILURE:
      if (PAYMENT_FORMS.includes(action.payload.id)) {
        return {
          ...state,
          retry: false,
        }
      }
      return state
    default:
      return state
  }
}
